import React, { useState } from "react";
import { Chip, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ContentCopy, Check } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
  chip: {
    cursor: "pointer",
    fontWeight: "600 !important",
    fontSize: "11px !important",
    height: "24px !important",
    backgroundColor: "#e3f2fd !important",
    color: "#1976d2 !important",
    border: "1px solid #90caf9 !important",
    "&:hover": {
      backgroundColor: "#bbdefb !important",
    },
  },
  icon: {
    fontSize: "14px !important",
  },
}));

interface CopyableTagProps {
  value: string;
  label?: string;
}

const CopyableTag: React.FC<CopyableTagProps> = ({ value, label }) => {
  const classes = useStyles();
  const [copied, setCopied] = useState(false);

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (value) {
      navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  if (!value || value === "-") {
    return <span>-</span>;
  }

  return (
    <Tooltip title={copied ? "Copied!" : "Click to copy"} arrow>
      <Chip
        label={label || value}
        onClick={handleCopy}
        onDelete={handleCopy}
        deleteIcon={
          copied ? (
            <Check className={classes.icon} />
          ) : (
            <ContentCopy className={classes.icon} />
          )
        }
        className={classes.chip}
        size="small"
      />
    </Tooltip>
  );
};

export default CopyableTag;
